export default __webpack_public_path__ + "static/media/logo-mark-reversed.cdf676ee.png";